export const endPoint =
  "https://" + process.env.REACT_APP_API_ENV + ".skidos.com/apis/productservice/v1/";
export const getUser =
  "https://" + process.env.REACT_APP_API_ENV + ".skidos.com/apis/userservice/v1/user";
export const getPlayers =
  "https://" +
  process.env.REACT_APP_API_ENV +
  ".skidos.com/apis/userservice/v1/player?&version=" +
  process.env.REACT_APP_SDK_VERSION +
  "";
export const getGames = "games/instant?premium=";
export const getVideos = "videos/unathulist?version=";
export const avatarBaseUrl = "https://images.skidos.com/instant-games/";
export const appPath = "https://skidos.com/app/";
export const homePage = "https://skidos.com/";
export const refreshTokenUrl =
  "https://" + process.env.REACT_APP_API_ENV + ".skidos.com/apis/userservice/v1/refresh/token";
